import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { IrregularidadeEmpresaDTO, TipoIrregularidadeEmpresaDTO } from './../../model/irregularidade-empresa.model';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { Injectable } from "@angular/core";
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class IrregularidadeEmpresaService extends FgiBackEndService<IrregularidadeEmpresaDTO> {

  getNewEntity() {
    return new IrregularidadeEmpresaDTO();
  }

  protected getResourceURL(): string {
    return 'front/irregularidade-empresa';
  }

  public buscarTodosTrancheAtual(params?: any): Observable<Array<IrregularidadeEmpresaDTO>> {
    let options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}/`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<IrregularidadeEmpresaDTO>>;
  }

  public buscarTiposIrregularidade(): Observable<Array<TipoIrregularidadeEmpresaDTO>> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/tipos`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<Array<TipoIrregularidadeEmpresaDTO>>;
  }

  public salvarOuAtualizar(tipoIrregularidade: string, dto: IrregularidadeEmpresaDTO): Observable<any> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/tipo/${tipoIrregularidade}`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }

  public buscarPorId (id: number): Observable<IrregularidadeEmpresaDTO> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<IrregularidadeEmpresaDTO>;
  }
}
